import React, { createContext, useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { selectUsers } from '../components/login/loginSlice';
import { useAccountBadges } from '../hooks/useAccountBadges';

const AccountBadgesContext = createContext(null);

export function AccountBadgesProvider({ children }) {
    const users = useSelector(selectUsers);
    const location = useLocation();
    const refreshKey = location.pathname;

    const badges = useAccountBadges(users, {
        enabled: users?.length > 0,
        refreshKey,
    });

    return (
        <AccountBadgesContext.Provider value={badges}>
            {children}
        </AccountBadgesContext.Provider>
    );
}

export function useAccountBadgesContext() {
    const ctx = useContext(AccountBadgesContext);
    if (!ctx) {
        return {
            byUserId: {},
            totals: { tasks: 0, documents: 0, chat: 0 },
            hasEmptyBankPack: false,
            loading: false,
            refresh: () => {},
            patchChatBadge: () => {},
        };
    }
    return ctx;
}

/** Счётчики по user_id для карточек пикера: tasks | documents | chat */
export function usePickerBadgeMap(section) {
    const { byUserId } = useAccountBadgesContext();

    return useMemo(() => {
        const map = {};
        Object.entries(byUserId || {}).forEach(([userId, row]) => {
            const id = Number(userId);
            if (!id) return;
            if (section === 'tasks') map[id] = row.tasks;
            else if (section === 'documents') map[id] = row.documents;
            else if (section === 'chat') map[id] = row.chat;
        });
        return map;
    }, [byUserId, section]);
}
